import React, { useEffect } from 'react'
import { Box, Toolbar } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { Header } from './layout/Header'
import { Routes } from './Routes'
import { errorEvents } from '../apollo/error-link'
import { useNotifications } from '../notifications/use-notifications'

export function Root(): React.ReactElement {
  const { enqueueError } = useNotifications()
  const { t } = useTranslation()

  useEffect(() => {
    const handleError = (event: Event) => {
      const errorEvent = event as ErrorEvent
      enqueueError(
        process.env.NODE_ENV === 'development'
          ? errorEvent.message
          : t('error.message'),
      )
    }

    errorEvents.addEventListener('error', handleError)

    return () => errorEvents.removeEventListener('error', handleError)
  }, [enqueueError, t])

  return (
    <Box display="flex" flexDirection="column" height="100%">
      <Header />

      {/* Allocate space for app bar. */}
      <Toolbar />

      <Box display="flex" flexGrow={1}>
        <Routes />
      </Box>
    </Box>
  )
}
